import React from 'react';
import { Divider } from 'material-ui';
import { prettifyDays } from '../../contractingUtils';
import R from 'ramda';

const Miscellaneous = ({
                         ratePackageName,
                         nettCommission,
                         rateType,
                         minStay,
                         maxStay,
                         daysOfWeek,
                         currency,
                         taxInclusion,
                         taxType,
                         stayPays,
                         commissionPercentage,
                         maxAdultsPlusChild,
  classes = {},
                       }) => {
  const commission = commissionPercentage ? <span className={classes['commissionPercentage']}>{`COMMISSION: ${commissionPercentage}%\n`}</span> : '';
  const basedCommission = nettCommission ? <span className={classes['nettCommission']}>{`NETT RATE BASED ON ${nettCommission}% COMMISSION\n`}</span> : '';
  const nightStay = (() => {
    if (minStay && maxStay) {
      return `${minStay} to ${maxStay} NIGHT${maxStay > 1 ? 'S' : ''} STAY`;
    } else if (minStay) {
      return `MIN ${minStay} NIGHT${minStay > 1 ? 'S' : ''} STAY`;
    } else if (maxStay) {
      return `MAX ${maxStay} NIGHT${maxStay > 1 ? 'S' : ''} STAY`;
    }
    return '';
  })();
  const taxText = (() => {
    if (taxInclusion === 'exempt') return 'are tax exempt';
    if (taxInclusion === 'exclusive') return 'are exclusive of tax';
    if (!taxType) return '';
    if (taxType === 'No sales tax') return 'there is no sales tax';
    return `are inclusive of ${taxType}`;
  })();
  if (nightStay || daysOfWeek || currency || taxText || ratePackageName) {
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px', fontSize: '12px', alignItems: 'flex-end' }}>
          <div style={{ width: '38%', textAlign: 'left', whiteSpace: 'pre', paddingLeft: '4px', lineHeight: '14px' }}>
            {ratePackageName ? `Rate Package: ${ratePackageName}\n` : ''}
            {rateType === 'includeCommission' ? commission : basedCommission}
            <div className={classes['minStay'] || classes['maxStay']}>{nightStay}</div>
            {daysOfWeek && daysOfWeek.length && prettifyDays(daysOfWeek) ?
              <div
                className={classes[R.keys(classes).find(str => str.indexOf('daysOfWeek') > -1)]}
              >
                {prettifyDays(daysOfWeek).toUpperCase()}
              </div> : ''}
            {maxAdultsPlusChild ?
              <div>Max Occupancy (Adults + Children): <span className={classes['maxAdultsPlusChild']}>{maxAdultsPlusChild}</span></div> : ''}
            {currency && taxText ?
              <div>Rates are in <span className={classes['currency']}>{currency}</span> and <span className={classes['taxInclusion'] || classes['taxType']}>{taxText}</span></div>
              : ''}
          </div>
          <div style={{ textAlign: 'right', paddingRight: '4px', lineHeight: '14px' }}>
            {
              // stayPays ? stayPays
              //   .filter(R.both(R.prop('stayDays'), R.prop('payDays')))
              //   .map(({ stayDays, payDays, maxFOC }, i) =>
              //     (<div key={i}>{`Stay ${stayDays} Pay ${payDays}${maxFOC && !isNaN(maxFOC) ? `, Max ${maxFOC} FOC Night${maxFOC > 1 ? 's' : ''} Allowed` : ''}`}</div>))
              //   : <div/>
            }
          </div>
        </div>
        <Divider style={{ marginTop: '4px' }} />
      </div>
    );
  }
  return <div/>;
};

export default Miscellaneous;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-tables/rates-table-miscellaneous.jsx